import { MediaType, MediaDocument } from '../models';

export class ContentDocumentTwitterAdapter {
    static toContentDocument(document: any): MediaDocument {
        const ICONOCLAST_URL = 'https://shuhari-iconoclast-production.herokuapp.com';
        const ICON_TVEYES_URL = 'http://tveyecons.meltwater.net';

        let contentDocument = new MediaDocument(document);
        let author = document.authors && document.authors[0] ? document.authors[0] : {};
        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.authors = document.authors.map((author: any) => {
            const copy = Object.assign({}, author);
            copy.name = copy.handle;
            return copy;
        });
        // contentDocument.body = Autolinker.link(document.matchSentence || document.tagContextMatchSentence || document.body, {mention: 'twitter', hashtag: 'twitter'});
        contentDocument.body = document.matchSentence || document.tagContextMatchSentence || document.body, {mention: 'twitter', hashtag: 'twitter'};
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.mediaType = document.mediaType;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarRounded = true;
        contentDocument.sourceAvatarImgUrl = author.avatarUrl ? author.avatarUrl : `${ICONOCLAST_URL}/tweeticon?handle=${author.handle}`;
        contentDocument.sourceAvatarLinkUrl = author.url;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = author.name || author.handle || 'Unknown';
        contentDocument.sourceNameUrl = author.url;
        contentDocument.tags = document.tags;
        contentDocument.language = document.language;
        contentDocument.engagement = document.engagement;
        contentDocument.engagementLastUpdateDate = document.engagementLastUpdateDate;
        contentDocument.socialScores = document.socialScores;
        contentDocument.mediaImageUrl = (document.images && document.images[0]) ? document.images[0].link : '';

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.redirectUrl || document.url || document.sourceUrl;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}
